import { IEntityId } from '../IEntityId';
import { ClubWebsite } from './club-website';
import { ClubCategory } from './club-category';

export interface Club extends IEntityId<string> {
  notes: string | null;
  location: string | null;
  latitude: number | null;
  longitude: number | null;
  contact: string | null;
  members: string | null;
  meets: string | null;
  country: string;
  status: ClubStatus;
  websites: ClubWebsite[];
  categories: ClubCategory[];
}

export enum ClubStatus {
  pending = 0,
  active = 1,
  inactive = 2,
  deleted = 3,
}
